$(function(ws) {
    'use strict';

    ws.views.customerDisputeCheck = Backbone.View.extend({
        mainError: '.cd-check-submit-error',
        mandatoryError: '.cd-check-mandatory-error',
        labelErrorClass: '.cd-check-label',

        /**
         * Initialize the component.
         */
        initialize: function() {
            this.$('input').attr('readonly', false);
            this.$('input').attr('disabled', false);
            this.$('textarea').attr('readonly', false);
            this.orderNumber = $('.order-meta-data').data('order-number');
            var mandatoryFieldSelectors = [
                'input#cdSalesOrg',
                'input#cdSoldTo',
                'input#cdCurrency',
                'input#cdPricing',
                'input#cdMatchingPO',
                'input#cdPONumber',
                'input#cdVatId',
                'input#cdShippingDetails',
                'input#cdDeliveryInstruction',
                'input#cdDeliveryAddress',
                'input#cdFreight'
            ];
            this.$approveMandatoryFields = this.$(mandatoryFieldSelectors.join(','));
            mandatoryFieldSelectors.push('textarea#cdComment');
            this.$removeMandatoryFields = this.$(mandatoryFieldSelectors.join(','));
            this.$cdSalesOrg = this.$('#cdSalesOrg');
            this.$cdSoldTo = this.$('#cdSoldTo');
            this.$cdCurrency = this.$('#cdCurrency');
            this.$cdPricing = this.$('#cdPricing');
            this.$cdMatchingPO = this.$('#cdMatchingPO');
            this.$cdFreight = this.$('#cdFreight');
            this.$cdPONumber = this.$('#cdPONumber');
            this.$cdVatId = this.$('#cdVatId');
            this.$cdShippingDetails = this.$('#cdShippingDetails');
            this.$cdDeliveryInstruction = this.$('#cdDeliveryInstruction');
            this.$cdDeliveryAddress = this.$('#cdDeliveryAddress');
            this.$cdComment = this.$('#cdComment');
        },

        events: _.extend({}, ws.views.form.prototype.events, {
            'click .approve-cd-checks': 'approveCdChecks',
            'click .reject-cd-checks': 'rejectCdChecks',
            'click .qc-approve-cd-checks': 'qcApproveCdChecks',
            'click .qc-reject-cd-checks': 'qcRejectCdChecks'
        }),

        approveCdChecks(e) {
            globals.disableApp();
            this.$('.approve-cd-checks').addClass('spinner-after no-padding').prop('disabled', true);
            this.removeFieldsCheck(this.$removeMandatoryFields);
            $(this.mainError).hide();
            this.error = false;

            var cdCheckModel = new ws.models.updateCdChecks({
                orderId: this.orderNumber
            });
            cdCheckModel.set({
                cdSalesOrg: this.$cdSalesOrg.is(':checked'),
                cdSoldTo: this.$cdSoldTo.is(':checked'),
                cdCurrency: this.$cdCurrency.is(':checked'),
                cdPricing: this.$cdPricing.is(':checked'),
                cdMatchingPO: this.$cdMatchingPO.is(':checked'),
                cdFreight: this.$cdFreight.is(':checked'),
                cdPONumber: this.$cdPONumber.is(':checked'),
                cdVatId: this.$cdVatId.is(':checked'),
                cdShippingDetails: this.$cdShippingDetails.is(':checked'),
                cdDeliveryInstruction: this.$cdDeliveryInstruction.is(':checked'),
                cdDeliveryAddress: this.$cdDeliveryAddress.is(':checked'),
                cdComment: this.$cdComment.val(),
                approved: true
            }, {
                silent: true
            });
            this.checkRequired(e, this.$approveMandatoryFields);
            if (!this.error) {
                cdCheckModel.save(null, {
                    type: 'POST'
                }).done(function(response) {
                    globals.enableApp();
                    this.$('.approve-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                    if (response.error) {
                        $(this.mainError).show();
                        this.removeFieldsCheck(this.$removeMandatoryFields);
                    }

                    if (response.cdStatus === 'APPROVED') {
                        this.disableFields(this.$removeMandatoryFields);
                        this.$('.approve-cd-checks').attr('disabled', true).css('pointer-events', 'none');
                        this.$('.reject-cd-checks').attr('disabled', true).css('pointer-events', 'none');
                    }
                }.bind(this)).fail(function() {
                    globals.enableApp();
                    this.$('.approve-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                    console.log('Error occured due to API failed');
                }.bind(this));
            }

            globals.enableApp();
            this.$('.approve-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
        },

        rejectCdChecks(e) {
            globals.disableApp();
            this.$('.reject-cd-checks').addClass('spinner-after no-padding').prop('disabled', true);
            this.removeFieldsCheck(this.$removeMandatoryFields);
            $(this.mainError).hide();
            this.error = false;
            var labelErrorClass = this.labelErrorClass;
            this.$cdComment.prevAll(labelErrorClass).removeClass('error');

            if (this.$cdComment.val() === '') {
                this.$cdComment.prevAll(labelErrorClass).addClass('error');
                globals.enableApp();
                this.$('.reject-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                return;
            }

            var cdCheckModel = new ws.models.updateCdChecks({
                orderId: this.orderNumber
            });
            cdCheckModel.set({
                cdSalesOrg: this.$cdSalesOrg.is(':checked'),
                cdSoldTo: this.$cdSoldTo.is(':checked'),
                cdCurrency: this.$cdCurrency.is(':checked'),
                cdPricing: this.$cdPricing.is(':checked'),
                cdMatchingPO: this.$cdMatchingPO.is(':checked'),
                cdFreight: this.$cdFreight.is(':checked'),
                cdPONumber: this.$cdPONumber.is(':checked'),
                cdVatId: this.$cdVatId.is(':checked'),
                cdShippingDetails: this.$cdShippingDetails.is(':checked'),
                cdDeliveryInstruction: this.$cdDeliveryInstruction.is(':checked'),
                cdDeliveryAddress: this.$cdDeliveryAddress.is(':checked'),
                cdComment: this.$cdComment.val(),
                rejected: true
            }, {
                silent: true
            });
                cdCheckModel.save(null, {
                    type: 'POST'
                }).done(function(response) {
                    globals.enableApp();
                    this.$('.reject-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                    if (response.error) {
                        $(this.mainError).show();
                        this.removeFieldsCheck(this.$removeMandatoryFields);
                    }

                    if (response.cdStatus === 'REJECTED') {
                        this.disableFields(this.$removeMandatoryFields);
                        this.$('.approve-cd-checks').attr('disabled', true).css('pointer-events', 'none');
                        this.$('.reject-cd-checks').attr('disabled', true).css('pointer-events', 'none');
                    }
                }.bind(this)).fail(function() {
                    globals.enableApp();
                    this.$('.reject-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                    console.log('Error occured due to API failed');
                }.bind(this));

            this.$('.reject-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
            globals.enableApp();
        },

        qcApproveCdChecks(e) {
            globals.disableApp();
            this.$('.qc-approve-cd-checks').addClass('spinner-after no-padding').prop('disabled', true);
            this.removeFieldsCheck(this.$removeMandatoryFields);
            $(this.mainError).hide();
            this.error = false;

            var cdCheckModel = new ws.models.updateCdChecks({
                orderId: this.orderNumber
            });
            cdCheckModel.set({
                cdSalesOrg: this.$cdSalesOrg.is(':checked'),
                cdSoldTo: this.$cdSoldTo.is(':checked'),
                cdCurrency: this.$cdCurrency.is(':checked'),
                cdPricing: this.$cdPricing.is(':checked'),
                cdMatchingPO: this.$cdMatchingPO.is(':checked'),
                cdFreight: this.$cdFreight.is(':checked'),
                cdPONumber: this.$cdPONumber.is(':checked'),
                cdVatId: this.$cdVatId.is(':checked'),
                cdShippingDetails: this.$cdShippingDetails.is(':checked'),
                cdDeliveryInstruction: this.$cdDeliveryInstruction.is(':checked'),
                cdDeliveryAddress: this.$cdDeliveryAddress.is(':checked'),
                cdComment: this.$cdComment.val(),
                qcApproved: true
            }, {
                silent: true
            });
            this.checkRequired(e, this.$approveMandatoryFields);
            if (!this.error) {
                cdCheckModel.save(null, {
                    type: 'POST'
                }).done(function(response) {
                    globals.enableApp();
                    this.$('.qc-approve-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                    if (response.error) {
                        $(this.mainError).show();
                    }

                    if (response.cdStatus === 'QC_APPROVED') {
                        this.disableFields(this.$removeMandatoryFields);
                        this.$('.qc-approve-cd-checks').attr('disabled', true).css('pointer-events', 'none');
                        this.$('.qc-reject-cd-checks').attr('disabled', true).css('pointer-events', 'none');
                        this.$cdComment.attr('disabled', true).css('pointer-events', 'none');
                    }
                }.bind(this)).fail(function() {
                    globals.enableApp();
                    this.$('.qc-approve-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                    console.log('Error occured due to API failed');
                }.bind(this));
            }
            globals.enableApp();
            this.$('.qc-approve-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
        },

        qcRejectCdChecks(e) {
            globals.disableApp();
            this.$('.qc-reject-cd-checks').addClass('spinner-after no-padding').prop('disabled', true);
            this.removeFieldsCheck(this.$removeMandatoryFields);
            $(this.mainError).hide();
            this.error = false;
            var labelErrorClass = this.labelErrorClass;
            this.$cdComment.prevAll(labelErrorClass).removeClass('error');

            if (this.$cdComment.val() === '') {
                this.$cdComment.prevAll(labelErrorClass).addClass('error');
                globals.enableApp();
                this.$('.qc-reject-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                return;
            }

            var cdCheckModel = new ws.models.updateCdChecks({
                orderId: this.orderNumber
            });
            cdCheckModel.set({
                cdSalesOrg: this.$cdSalesOrg.is(':checked'),
                cdSoldTo: this.$cdSoldTo.is(':checked'),
                cdCurrency: this.$cdCurrency.is(':checked'),
                cdPricing: this.$cdPricing.is(':checked'),
                cdMatchingPO: this.$cdMatchingPO.is(':checked'),
                cdFreight: this.$cdFreight.is(':checked'),
                cdPONumber: this.$cdPONumber.is(':checked'),
                cdVatId: this.$cdVatId.is(':checked'),
                cdShippingDetails: this.$cdShippingDetails.is(':checked'),
                cdDeliveryInstruction: this.$cdDeliveryInstruction.is(':checked'),
                cdDeliveryAddress: this.$cdDeliveryAddress.is(':checked'),
                cdComment: this.$cdComment.val(),
                qcRejected: true
            }, {
                silent: true
            });
            cdCheckModel.save(null, {
                type: 'POST'
            }).done(function(response) {
                globals.enableApp();
                this.$('.qc-reject-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                if (response.error) {
                    $(this.mainError).show();
                }

                if (response.cdStatus === 'QC_REJECTED') {
                    this.disableFields(this.$removeMandatoryFields);
                    this.$('.qc-approve-cd-checks').attr('disabled', true).css('pointer-events', 'none');
                    this.$('.qc-reject-cd-checks').attr('disabled', true).css('pointer-events', 'none');
                    this.$cdComment.attr('disabled', true).css('pointer-events', 'none');
                }
            }.bind(this)).fail(function() {
                globals.enableApp();
                this.$('.qc-reject-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
                console.log('Error occured due to API failed');
            }.bind(this));

            this.$('.qc-reject-cd-checks').removeClass('spinner-after no-padding').prop('disabled', false);
            globals.enableApp();
        },

        checkRequired(ev, $fields) {
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }

            return this.checkEmptyFields($fields);
        },

        checkEmptyFields($fields) {
            _.each($fields, function(field) {
                var $field = $(field);
                if (($.trim($field.val()) === '' && $field[0].type === 'textarea') || (!$field.prop('checked') && $field[0].type === 'checkbox')) {
                    this.handleError($field);
                    this.error = true;
                }
            }.bind(this));
        },

        handleError($field) {
            var labelErrorClass = this.labelErrorClass;
            $field.nextAll(labelErrorClass).addClass('error');
            $field.prevAll(labelErrorClass).addClass('error');
            $(this.mandatoryError).show();
        },

        removeFieldsCheck($fields) {
            _.each($fields, function(field) {
                var $field = $(field);
                var labelErrorClass = this.labelErrorClass;
                $field.nextAll(labelErrorClass).removeClass('error');
                $field.prevAll(labelErrorClass).removeClass('error');
            $(this.mandatoryError).hide();
            }.bind(this));
        },

        disableFields($fields) {
            _.each($fields, function(field) {
                var $field = $(field);
                $field.attr('disabled', true).css('pointer-events', 'none');
            }.bind(this));
        }
    });
}(westcon));
